export const importDataModalState = {
    description: undefined,
    referenceDate: new Date(),
    selectFile: undefined,
    uploadName: ""
};
